import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { runRtkQuery } from '../helperFn';

export const externalApi = createApi({
  reducerPath: 'externalApi',
  baseQuery: baseQuery,
  tagTypes: ['tsysTransactionKey'],
  endpoints: (builder) => ({
    createTsysTransactionKey: builder.mutation({
      query: (payload) => ({
        url: '/externalJSONrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'createTsysTransactionKey');
      },
      providesTags: ['tsysTransactionKey'],
    }),
  }),
});

export const { useCreateTsysTransactionKeyMutation } = externalApi;
